import { render, staticRenderFns } from "./Traduccion.vue?vue&type=template&id=0c299b56&scoped=true&"
import script from "./Traduccion.vue?vue&type=script&lang=js&"
export * from "./Traduccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c299b56",
  null
  
)

export default component.exports